export default __webpack_public_path__ + "static/media/01.8b5d5e05.mp3";